import { createInstance, enums, OptimizelyProvider, useDecision } from '@optimizely/react-sdk';
import { useUserContext } from '@fff-web/fff-utilities';
import { LegalItem } from '../../services/types';
import { getOptimizelyFeSdkKey } from '../../utils/getEnv';
import { LegalFooter } from './LegalFooter';
import { isOptOutState, useGeoState } from './useGeoState';

const ONETRUST_OPTOUT_LOGGED_IN_FLAG = 'onetrust_optout_logged_in';

let optimizelyInstance: ReturnType<typeof createInstance> | null = null;
const getOptimizely = () => {
  if (!optimizelyInstance) {
    optimizelyInstance = createInstance({
      sdkKey: getOptimizelyFeSdkKey(),
      logLevel: enums.LOG_LEVEL.ERROR,
    });
  }
  return optimizelyInstance;
};

interface Props {
  legals: LegalItem[];
  isLoggedIn: boolean;
}

const LegalFooterWithFlag = ({ legals }: Pick<Props, 'legals'>) => {
  const [decision] = useDecision(ONETRUST_OPTOUT_LOGGED_IN_FLAG);

  return (
    <LegalFooter
      legals={legals}
      isLoggedIn
      showOptOutWhenLoggedIn={decision.variationKey === 'on'}
    />
  );
};

const LegalFooterContainer = ({ legals, isLoggedIn }: Props) => {
  const { userInfo } = useUserContext();
  const geoState = useGeoState();

  if (!isLoggedIn || !isOptOutState(geoState)) {
    return <LegalFooter legals={legals} isLoggedIn={isLoggedIn} />;
  }

  const userId = String(userInfo?.user?.userId ?? userInfo?.user?.uuid ?? 'anonymous');

  return (
    <OptimizelyProvider optimizely={getOptimizely()} user={{ id: userId }}>
      <LegalFooterWithFlag legals={legals} />
    </OptimizelyProvider>
  );
};

export { LegalFooterContainer };
